import { FirebaseError } from 'firebase/app';

/**
 * Gère les erreurs Firestore et affiche des messages spécifiques pour les problèmes d'index
 */
export const handleFirestoreError = (error: unknown, context: string = 'Firestore operation'): void => {
  if (error instanceof FirebaseError) {
    // Erreur d'index Firestore
    if (error.code === 'failed-precondition' || 
        error.message.includes('index') || 
        error.message.includes('The query requires an index')) {
      console.error(`🚨 ERREUR D'INDEX FIRESTORE [${context}]:`, {
        code: error.code,
        message: error.message,
        context,
        suggestion: 'Veuillez créer l\'index Firestore manquant. Consultez la console Firebase pour plus de détails.'
      });
    }
    // Erreur de permissions
    else if (error.code === 'permission-denied') {
      console.error(`🚨 ERREUR DE PERMISSIONS [${context}]:`, {
        code: error.code,
        message: error.message,
        context,
        suggestion: 'Vérifiez les règles Firestore et les permissions utilisateur.'
      });
    }
    // Autres erreurs Firebase
    else {
      console.error(`🚨 ERREUR FIRESTORE [${context}]:`, {
        code: error.code,
        message: error.message,
        context
      });
    }
  } else {
    // Erreur non-Firebase
    console.error(`🚨 ERREUR [${context}]:`, error);
  }
};

/**
 * Wrapper pour les requêtes Firestore qui gère automatiquement les erreurs
 */
export const withFirestoreErrorHandling = async <T>(
  operation: () => Promise<T>,
  context: string = 'Firestore operation'
): Promise<T> => {
  try {
    return await operation();
  } catch (error) {
    handleFirestoreError(error, context);
    throw error; // Re-throw pour que l'appelant puisse gérer
  }
};
